import type { DrawerProps } from '@mui/material/Drawer';
import { alpha, type Theme } from '@mui/material/styles';

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiDrawer: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: DrawerProps }) => ({
          ...(ownerState.variant === 'temporary' && {
            '& .MuiDrawer-paper': {
              boxShadow: `-40px 40px 80px -8px ${alpha(
                isLight ? theme.palette.slate[500] : theme.palette.common.black,
                0.24,
              )}`,
            },
          }),
          ...(ownerState.hideBackdrop && {
            inset: 'unset !important',
          }),
        }),
      },
    },
  };
}
